import * as React from "react"

import { HandSelectionOutline } from "@behaviour-lab/blab-component-library"

import { BUY_SELECTION_ROUTE } from "../routes"

type IconProps = {
  className?: string
}

// ToDo: to revert back the nested sub menu, check commit 775537ee8f569c3e1b415cb8ee3a33db26a44538
const buyingLink = {
  label: "Buy Selection",
  to: BUY_SELECTION_ROUTE,
  Icon: ({ className }: IconProps) => (
    <HandSelectionOutline className={className} />
  ),
}

export default buyingLink
